import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import React, { useEffect, useRef } from "react";
import { radiusZoomLevel } from "../../utils/staticMethods";

const DrawingManagerSelectEditor = ({
  selectedGeometry,
  // centerPoint,
  // onCenterPointChanged,
}) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMarker = useMapsLibrary("marker");
  const mapLibGeometry = useMapsLibrary("geometry");

  useEffect(() => {
    if (!map || !mapLibCore || !mapLibMarker || !mapLibGeometry) return;

    if (selectedGeometry) {
      selectedGeometry &&
        selectedGeometry.setOptions({
          map,
          editable: true,
          draggable: true,
          clickable: true,
        });

      // If polygon, add marker for center point
      if (selectedGeometry.type && selectedGeometry.type === "polygon") {
        const div = document.createElement("div");
        div.style.width = "12px";
        div.style.height = "12px";
        div.style.background = "#1976D2";
        div.style.borderRadius = "40%";
        div.style.border = "2px solid white";
        // div.style.position = "absolute";
        div.style.translate = "0px 5px";

        var center;
        if (selectedGeometry.center) {
          center = selectedGeometry.center;
        } else {
          center = getCenterPointForPolygon(selectedGeometry);
          selectedGeometry.center = center;
        }

        var centerMarker = new mapLibMarker.AdvancedMarkerElement({
          map,
          position: center,
          content: div,
          gmpDraggable: true,
        });

        centerMarker.addListener("dragend", (ev) => {
          selectedGeometry.center = ev.latLng;
        });

        selectedGeometry.addListener("dragend", (e) => {
          let center = getCenterPointForPolygon(selectedGeometry);
          selectedGeometry.center = center;
          centerMarker.position = center;
        });

        selectedGeometry.getPath().addListener("set_at", (e) => {
          let center = getCenterPointForPolygon(selectedGeometry);
          selectedGeometry.center = center;
          centerMarker.position = center;
        });
      }
    }

    // Cleanup
    return () => {
      if (centerMarker) {
        mapLibCore.event.clearInstanceListeners(centerMarker);
        centerMarker.setMap(null);
        centerMarker = undefined;
      }
      if (selectedGeometry) {
        if (selectedGeometry.type === "polygon")
          mapLibCore.event.clearInstanceListeners(selectedGeometry.getPath());
        mapLibCore.event.clearInstanceListeners(selectedGeometry);
        selectedGeometry.setOptions({
          editable: false,
          draggable: false,
          clickable: false,
        });
      }
    };
  }, [selectedGeometry, map, mapLibCore, mapLibMarker, mapLibGeometry]);

  useEffect(() => {
    if (!map || !selectedGeometry || !mapLibGeometry) return;

    if (selectedGeometry.center) {
      // pan and zoom the map to the selected geometry
      map.panTo(selectedGeometry.center);

      if (selectedGeometry.type === "polygon") {
        // Get the path and calculate the largest length of bounding box
        // Zoom level based on this
        let path = selectedGeometry.getPath();
        let firstItem = path.getAt(0);
        let minLat = {
            lat: Number(firstItem.lat()),
            lng: Number(firstItem.lng()),
          },
          maxLat = {
            lat: Number(firstItem.lat()),
            lng: Number(firstItem.lng()),
          },
          minLng = {
            lat: Number(firstItem.lat()),
            lng: Number(firstItem.lng()),
          },
          maxLng = {
            lat: Number(firstItem.lat()),
            lng: Number(firstItem.lng()),
          };
        path.forEach((item, index) => {
          let lng = Number(item.lng());
          let lat = Number(item.lat());
          if (lat > maxLat.lat) maxLat = { lat, lng };
          if (lat < minLat.lat) minLat = { lat, lng };
          if (lng > maxLng.lng) maxLng = { lat, lng };
          if (lng < minLng.lng) minLng = { lat, lng };
        });

        let point1 = new mapLibCore.LatLng(minLat);
        let point2 = new mapLibCore.LatLng(maxLat);
        let point3 = new mapLibCore.LatLng(minLng);
        let point4 = new mapLibCore.LatLng(maxLng);
        let d1 = mapLibGeometry.spherical.computeDistanceBetween(
          point1,
          point2
        );
        let d2 = mapLibGeometry.spherical.computeDistanceBetween(
          point3,
          point4
        );
        let d = d1 > d2 ? d1 : d2;

        let keys = Object.keys(radiusZoomLevel).reverse();
        let value = 1000000;
        let index = 0;
        for (let i = 0; i < keys.length; i++) {
          let v = Math.abs(radiusZoomLevel[keys[i]] - d);
          if (v < value) {
            value = v;
            index = keys[i];
          }
        }
        map.setZoom(Number(index - 1));
      } else {
        let keys = Object.keys(radiusZoomLevel).reverse();
        let value = 1000000;
        let index = 0;
        for (let i = 0; i < keys.length; i++) {
          let v = Math.abs(
            radiusZoomLevel[keys[i]] - Number(selectedGeometry.getRadius()) * 2
          );
          if (v < value) {
            value = v;
            index = keys[i];
          }
        }
        map.setZoom(Number(index) - 1);
      }
    }

    // if (!mountedRef.current || foundCenterRef.current) return;

    // if (!centerPoint) {
    //   if (selectedGeometry.type === "circle") {
    //     onCenterPointChanged &&
    //       onCenterPointChanged(selectedGeometry.getCenter());
    //   } else {
    //     onCenterPointChanged &&
    //       onCenterPointChanged(getCenterPointForPolygon(selectedGeometry));
    //   }
    // } else {
    //   map.panTo(centerPoint);
    // }

    // foundCenterRef.current = true;
  }, [map, selectedGeometry, mapLibGeometry]);

  const getCenterPointForPolygon = (polygon) => {
    let v = polygon.getPath();
    let pathArray = [];
    let bounds = new mapLibCore.LatLngBounds();
    for (let i = 0; i < v.getLength(); i++) {
      let xy = v.getAt(i);
      let filter = pathArray.filter((item) => {
        let spit = item.split(",");
        return (
          spit[0] === xy.lng().toString() && spit[1] === xy.lat().toString()
        );
      });
      if (filter.length === 0) {
        pathArray.push(xy.lng() + "," + xy.lat());
        bounds.extend(new mapLibCore.LatLng(xy.lat(), xy.lng()));
      }
    }
    let end = pathArray[0].split(",");
    bounds.extend(new mapLibCore.LatLng(end[1], end[0]));

    return bounds.getCenter();
  };

  return null;
};

export default DrawingManagerSelectEditor;
